import { AutocompleteProps } from 'types/autocomplete';
import Autocomplete from '../Autocomplete';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
interface BankCardAutocompleteProps extends Omit<AutocompleteProps, 'options'> {}

const BankCardAutocomplete = (props: BankCardAutocompleteProps) => {
    const moneyContainerList = useSelector((state: RootState) => state.moneyContainer?.moneyContainerList) || [];

    return (
        <Autocomplete
            options={moneyContainerList}
            getOptionLabel={(option) => 'Checking****' + option?.detail?.last4AccountDigits}
            {...props}
        />
    );
};

export default BankCardAutocomplete;
